import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMetricsFluorTable = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M17.481 10.193 7.635 7.635l2.558 9.845zm20.892 8.654v10.306L47.144 24zm-.566-1.367 2.558-9.845-9.846 2.558zm-8.654-7.853L24 .856l-5.153 8.771zm-19.526 9.22L.856 24l8.771 5.153zm20.892 18.96 9.846 2.558-2.558-9.845zm-11.672.566L24 47.144l5.153-8.771zm-8.654-7.853-2.558 9.845 9.846-2.558zm18.524-17.907h-9.434l-6.67 6.67v9.434l6.67 6.67h9.434l6.67-6.67v-9.434zm.436 13.522-3.019 3.018h-4.269l-3.018-3.018v-4.27l3.018-3.018h4.269l3.019 3.018z" }) }) })
});
export default SvgMetricsFluorTable;
